export class ExecuteCommand {
  outputPort: number;
  codPerif: string;
  source: string;
  pulseDuration: number;
  value: boolean;
  clientLatitude: number | undefined;
  clientLongitude: number | undefined;

  constructor(data: Partial<ExecuteCommand> = {}) {
    this.outputPort = data?.outputPort ?? 0;
    this.codPerif = data?.codPerif ?? '';
    this.source = data?.source ?? '';
    this.pulseDuration = data?.pulseDuration ?? 0;
    this.value = data?.value ?? false;
    this.clientLatitude = data?.clientLatitude;
    this.clientLongitude = data?.clientLongitude;
  }
}
